import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-9d7fc16c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "music-progress",
  class: "progress-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    ref: "progressRef",
    class: "progress-outer",
    style: _normalizeStyle(_ctx.outerStyle)
  }, [_createElementVNode("div", {
    class: "progress-inner-wrapper",
    style: _normalizeStyle(_ctx.innerWrapperStyle)
  }, [_createElementVNode("div", {
    style: _normalizeStyle(_ctx.innerStyle)
  }, null, 4
  /* STYLE */
  )], 4
  /* STYLE */
  ), _createElementVNode("div", {
    class: "change-percentage",
    style: _normalizeStyle(_ctx.percentageStyle)
  }, null, 4
  /* STYLE */
  )], 4
  /* STYLE */
  )]);
}